// Entry for dist/js/auth.js, loaded synchronously in <head> before the app bundle.
// It sends studio routes to the right host, then exposes the auth helpers as
// window.AHAuth (the app bundle's sa() returns AHAuth.getSupabase(); also used
// by compliance/signup.js) and the studio uploader as window.AHStudio.

import * as auth from './auth';
import { routeStudioHost } from './studio-host';
import * as studio from './studio-upload';
import * as content from './live-content';
import { installMediaRenewal } from './media-renewal';
installMediaRenewal(async id => {
  const session = await auth.getSession();
  const response = await fetch(`/api/videos/${id}/playback`, { cache: 'no-store', headers: session ? { Authorization: `Bearer ${session.access_token}` } : {} });
  const body = await response.json();
  if (!response.ok) throw new Error(body.error || 'Playback unavailable.');
  return body;
});

declare global {
  interface Window {
    AHAuth: typeof auth;
    AHStudio: typeof studio;
    AHContent: typeof content;
  }
}

routeStudioHost();
window.AHAuth = auth;
window.AHStudio = studio;
window.AHContent = content;
